import { useAuth, useClerk, useUser } from '@clerk/react';
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Container, Stack, Typography } from '@mui/material';
import { currentUser } from '../auth-provider';
import { extractApiError } from '../lib/api-client';

export function AccessPage() {
  const { signOut } = useClerk();
  const { user } = useUser();
  const { isLoaded, isSignedIn } = useAuth();
  const [reason, setReason] = useState<string | null>(null);
  const [destination, setDestination] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;
    let active = true;
    void currentUser().then((account) => {
      if (!active) return;
      if (account.role === 'STAFF') {
        setDestination(account.admin_scope === 'PLATFORM' ? '/platform/dashboard' : '/dashboard');
        setReason(null);
      }
      else setReason('This Clerk account does not have an administrator role.');
    }).catch((error: unknown) => {
      if (active) setReason(extractApiError(error).message);
    });
    return () => { active = false; };
  }, [isLoaded, isSignedIn]);
  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h4" fontWeight={700}>Property access</Typography>
        <Alert severity={destination ? 'success' : 'info'} sx={{ width: '100%' }}>
          {destination
            ? `Admin access confirmed for ${user?.primaryEmailAddress?.emailAddress ?? 'this account'}.`
            : `Access for ${user?.primaryEmailAddress?.emailAddress ?? 'this account'} could not be confirmed.${reason ? ` ${reason}` : ' Checking your property assignments…'}`}
        </Alert>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="contained" onClick={() => window.location.assign(destination ?? '/dashboard')}>
            {destination ? 'Continue to admin' : 'Retry access'}
          </Button>
          <Button variant="outlined" onClick={() => void signOut({ redirectUrl: '/login' })}>Sign out</Button>
        </Box>
      </Stack>
    </Container>
  );
}
